// extracted by mini-css-extract-plugin
module.exports = {"root":"ProductDetailsItem_root__KxLN3","title":"ProductDetailsItem_title__6AML1","code":"ProductDetailsItem_code__kvGV3"};